var _circle, _circle2, _rect, _rect2, _rect3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMarble = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    fill: "#EBFAF8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.8941,
    cy: 42.106,
    r: 28.9667,
    fill: "#2CAECB",
    stroke: "#3F5574",
    strokeWidth: 1.72149
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.16479,
    y: 48.1547,
    width: 11.6615,
    height: 4.99776,
    rx: 2.49888,
    fill: "#2CAECB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.16479,
    y: 31.4922,
    width: 11.6615,
    height: 4.99776,
    rx: 2.49888,
    fill: "#2CAECB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 39.8251,
    width: 13.3274,
    height: 4.99776,
    rx: 2.49888,
    fill: "#2CAECB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.3099 40.8572C76.7419 41.2584 76.7348 41.9442 76.2948 42.3364L59.1262 57.6385C58.3323 58.3462 57.129 57.4896 57.5376 56.5078L63.0421 43.282C63.5404 42.0845 63.554 40.7403 63.0799 39.533L57.906 26.3589C57.5172 25.3688 58.7379 24.5367 59.5173 25.2606L76.3099 40.8572Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMarble);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Marble.c43cfd7c33c9b2a39b2e72b0cddce486.svg";